import React, { useCallback, useState } from 'react';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';

function ResultTooltip() {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);

  const handleClick = useCallback(() => {
    setOpen(!open);
  }, [open]);
  return (
    <div className="accuracy-tooltip">
      <button
        onClick={handleClick}
        className="btn-help btn-tooltip"
      ></button>
      <div
        onClick={handleClick}
        className={clsx({
        "tooltip-def tooltipBox": true,
        "active": open
      })}>
        <p dangerouslySetInnerHTML={{ __html: t("LC_05_07_04.msg004")}}/>
        <button className="btn-closeTooltip btn-close-tooltip"></button>
      </div>
    </div>
  );
}

export default ResultTooltip;